// // permissions.js
// export const ROLE_PERMISSIONS = {
//   admin: ["map", "dashboard", "user", "projects", "tree-species", "subscription"],
//   client_admin: ["map", "dashboard", "user", "subscription"],
//   project_admin: ["map", "dashboard", "user", "subscription"],
//   surveyor: ["map", "dashboard", "tree-survey", "subscription"]
// };

export const ROLE_PERMISSIONS = {
  admin: ["map", "dashboard", "user", "projects", "tree-species", "subscription", "report"],
  client_admin: ["map", "dashboard", "user", "projects","subscription", "report"],
  project_admin: ["map", "dashboard", "user", "projects","subscription", "report"],
  // surveyor: ["map", "dashboard", "tree-survey", "subscription"]
};